<div class="dialog-panel">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <div [ngClass]="{ 'v-hidden': loading }">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'global.not_logged_in' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        <div class="auth-other-actions mb-5">
          <div class="d-block">
            {{ 'auth.already_have_account' | transloco }}
          </div>
          <div class="d-block text-center mt-2">
            <button class="btn btn-secondary" (click)="openDialog('signin')">
              {{ 'global.signin' | transloco }}
            </button>
          </div>
        </div>
        <div class="auth-other-actions mb-4">
          <div class="d-block">
            {{ 'auth.dont_have_account' | transloco }}
          </div>
          <div class="d-block text-center mt-2">
            <button class="btn btn-secondary" (click)="openDialog('signup')">
              {{ 'global.signup' | transloco }}
            </button>
          </div>
        </div>
        @if (data?.guest) {
          <div class="auth-other-actions">
            <div class="d-block or">
              {{ 'global.or' | transloco }}
            </div>
            <div class="d-block">
              <button type="button" class="btn btn-text" (click)="redirect()">
                {{ 'auth.continue_as_guest' | transloco }}
                <span>
                  {{ 'auth.click_here' | transloco }}
                </span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
